import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';

interface Props {
  testId: TestId;
}

export default function ActivationAlert({ testId }: Props) {
  return (
    <div
      className="bg-warning-strong relative -top-3.5 z-4 -mb-3.5 rounded-b-2xl px-4 pt-5 pb-2 text-center text-sm text-balance text-white"
      data-testid={testId}
    >
      {tr('owned_parking_manage:parking_statuses.draft.activation.cant_request.alert')}
    </div>
  );
}
